export default class LeadOrigin {
  id?: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): LeadOrigin {
    return new LeadOrigin(obj || {});
  }

  public static ofList(obj: any[]): LeadOrigin[] {
    return obj.map(this.of);
  }
}
